'use client'
import { useEffect } from 'react'
import classnames from 'classnames'

import isClient from '@/utils/browser/isClient'
import styles from './styles.module.scss'
import Button from '../Button'

import closeImage from '/public/icons/close.svg'
import Image from 'next/image'

const Modal = ({
  children,
  isOpened,
  onCloseClick,
  variant = 'center',
  hasCloseButton = true,
  hasFooterButton = true,
  FooterButtonText = 'Fechar',
  title = '',
  className
}) => {
  useEffect(() => {
    if (isClient() && isOpened) {
      const btnClose = document.querySelector(`.${styles.modal__close}`)
      btnClose && btnClose.focus()
    }
  }, [isOpened])

  return (
    <div
      className={classnames(styles.modal, className, {
        [styles['modal--opened']]: isOpened,
        [styles[`modal--${variant}`]]: !!variant
      })}
      role="alertdialog"
      aria-modal="true"
      title="modal"
    >
      <div
        className={`${styles.modal__curtain} ${isOpened ? styles['modal__curtain--opened'] : ''}`}
        onClick={onCloseClick}
      ></div>
      <div
        className={classnames(styles.modal__box, {
          [styles['modal__box--opened']]: isOpened,
          [styles[`modal__box--${variant}`]]: !!variant
        })}
      >
        <div className={styles.modal__header}>
          {title && <h2 className={styles.modal__headerTitle}>{title}</h2>}
          {hasCloseButton && (
            <button
              aria-label="Fechar o modal"
              className={styles.modal__close}
              onClick={onCloseClick}
            >
              <Image
                src={closeImage}
                alt="Fechar modal"
                width={20}
                height={20}
              />
            </button>
          )}
        </div>
        <div className={styles.modal__content}>{children}</div>
        {hasFooterButton && (
          <Button
            onClick={onCloseClick}
            variant="secondary"
            fluid
            rightIcon={'arrow-right'}
            className={styles.modal__btnClose}
          >
            {FooterButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Modal
